/**
 * Where the dashboard is mounted.
 *
 * Normally that is the root of its own domain, but it can also live under a
 * path on a domain that serves other things (for example a client's site at
 * `/admin/`). Vite bakes the mount point into the bundle as `BASE_URL`; this
 * turns it into a prefix with no trailing slash: `''` at the root, otherwise
 * something like `/pssmdemo1/admin`.
 */
export function normaliseBasePath(baseUrl: string): string {
  const trimmed = baseUrl.trim().replace(/\/+$/, '');
  if (trimmed === '' || trimmed === '.') return '';
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
}

export const BASE_PATH = normaliseBasePath(import.meta.env.BASE_URL);

/** Prefixes an app-relative path (`/app/x`) with the mount point, for hard navigations. */
export function withBasePath(path: string): string {
  return `${BASE_PATH}${path.startsWith('/') ? path : `/${path}`}`;
}
